module.exports = __webpack_public_path__ + "static/img/nals-1.d51a6bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/nals/nals-1.jpg
// module id = 7ZvQ
// module chunks = 0